"use strict";

/**
 * Прикладные действия.
 *
 * @namespace WebAccess.actions
 */

(function (global) {

  /**
   * Запуск действия.
   * @since 5.6.0.1000
   * @function WebAccess.actions.executeAction
   * @param {string} actionName Имя действия.
   * @param {object} entityLink Ссылка WA.Link на объект, действие над которым вызывается.
   * @param {object} form Форма, к которой должны примениться изменения после выполнения действия.
   * @param {object} [opt_params] Параметры действия или диалог WebAccess.components.dialogs.FormDialog, тогда значения реквизитов диалога скопируются в параметры объекта для работы действия.
   * @example
   * WebAccess.actions.executeAction('ActionName', new WA.Link(111, OBJECT_TYPE.FOLDER, "")).done(function() { console.log('Действие завершилось!'); });
   */
  global.executeAction = (actionName, entityLink, form, opt_params) => {
    let serializedForm;
    if (opt_params && opt_params.className === 'FormDialog') {
      // Копируем реквизиты диалога в параметры действия.
      let dialog = opt_params;
      serializedForm = dialog.form.serialize({
        onlyValue: true,
        returnRowNumber: true,
        withoutTables: true,
        transformMultiReqsToDetailRows: true,
      });
    } else {
      serializedForm = {
        requisites: opt_params,
      };
    }
    return setDomainActionResultAndExecuteAgain(actionName, entityLink, form, serializedForm);
  }

  /**
   * Запуск действия над контентом папки.
   * @since 5.6.0.1000
   * @function WebAccess.actions.executeContentAction
   * @param {string} actionName Имя действия.
   * @param {WA.Link} folderLink Ссылка на папку, над содержимым которой вызывается действие.
   * @example
   * WebAccess.actions.executeContentAction('ActionName', new WA.Link(111, OBJECT_TYPE.FOLDER, "")).done(function() { console.log('Действие завершилось!'); });
   */
  global.executeContentAction = (actionName, folderLink) => {
    return setContentActionResultAndExecuteAgain(actionName, folderLink);
  };

  /**
   * Запуск действия с предварительный показов диалога.
   * @since 5.0.0.1901
   * @function WebAccess.actions.showDialogAndExecuteAction
   * @param {string} actionName Имя действия.
   * @param {string} dialogName Имя диалога.
   * @param {object} entityLink Ссылка WA.Link на объект, действие которого запускается.
   * @param {object} form Форма, к которой должны примениться изменения после выполнения действия.
   * @example
   * WebAccess.actions.showDialogAndExecuteAction('ActionName','DialogName').done(function() { console.log('Действие завершилось!'); });
   */
  global.showDialogAndExecuteAction = (actionName, dialogName, entityLink, form) => {
    if (dialogName) {
      // Отображение диалога.
      WA.FC.dialogs.getObjectByName(dialogName, MODEL.FULL).done((dialog) => {
        dialog.show();
        dialog.bind(WA.CMP.dialogs.FormDialog.EVENT.AFTER_ACTION, (dialogActionName, result) => {
          if (dialogActionName === DIALOG_ACTION.OK) {
            return global.executeAction(actionName, entityLink, form, dialog);
          }
        });
      });
    } else {
      return setActionResultAndExecuteAgain(actionName, entityLink, form);
    }
  };

  /**
   * Уставливает результат действия и запускает его повторно.
   * @since 5.0.0.1600
   * @function BaseObjectModel.setActionResultAndExecuteAgain
   * @private
   */
  function setActionResultAndExecuteAgain(actionName, entityLink, form, serializedForm, commandNumber, commandType, commandResult) {
    if (entityLink.type === OBJECT_TYPE.FOLDER) {
      return setContentActionResultAndExecuteAgain(actionName, entityLink, commandNumber, commandType, commandResult);
    } else {
      return setDomainActionResultAndExecuteAgain(actionName, entityLink, form, serializedForm, commandNumber, commandType, commandResult);
    }
  }

  /**
   * Передать результат выполнения пост-обработки действия над контентом и вызвать действие повторно.
   * @since 5.6.0.1000
   * @param {string} actionName Имя действия.
   * @param {WA.Link} folderLink Ссылка на папку, над содержимым которой вызывается действие.
   * @param {number} commandNumber Номер команды.
   * @param {number} commandType Тип команды.
   * @param {object} commandResult Результат выполнения команды.
   */
  function setContentActionResultAndExecuteAgain(actionName, folderLink, commandNumber, commandType, commandResult) {
    let result = $.Deferred();
    let content = {
      folderId: folderLink.id,
      isAllItemsSelected: WA.CR.objectList.isAllItemsSelected(),
      filter: WA.CR.objectList.getLikeFilter(),
    };
    if (content.isAllItemsSelected) {
      content.unselectedItems = WA.CR.objectList.getUnselectedItems();
    } else {
      content.selectedItems = WA.CR.objectList.getSelectedItems();
    };
    const filterRequisite = WA.CR.objectList.getlikeFilterRequisites();
    if (filterRequisite) {
      content.filterRequisites = filterRequisite.split(';');
      };
    let reinvokeParameters = {
      commandNumber: commandNumber,
      commandType: commandType,
      commandResult: commandResult,
    };
    WA.SRV.foldercontent.executeAction(actionName, content, reinvokeParameters).done((response) => {
      let responseAsObject = $.parseJSON(response);

      //скрываем сообщения о предыдущих ошибках, если были
      $.when(WA.FormControlsInit).then(() => {
        WA.CMP.NTF.InlineHint.hideAll();
      });

      // Выполнение комманд.
      let cmds = responseAsObject.Commands;
      performCommands(cmds, folderLink, actionName);

      result.resolve();

    }).fail((errorMessage, response) => {
      if (response) {
        result.reject(response.Error);
      } else {
        result.reject();
      }
    });

    return result.promise();
  }

  /**
   * Передать результат выполнения пост-обработки действия над объектом и вызвать действие повторно.
   * @since 5.6.0.1000
   * @param {string} actionName Имя действия.
   * @param {WA.Link} entityLink Ссылка на папку, над содержимым которой вызывается действие.
   * @param {object} form Форма, к которой должны примениться изменения после выполнения действия.
   * @param {string} serializedForm текущее состояние формы в сериализованном виде.
   * @param {number} commandNumber Номер команды.
   * @param {number} commandType Тип команды.
   * @param {object} commandResult Результат выполнения команды.
   * @private
   */
  function setDomainActionResultAndExecuteAgain(actionName, entityLink, form, serializedForm, commandNumber, commandType, commandResult) {    
    let result = $.Deferred();

    WA.SRV.call('/Action.asmx/Execute', {
      Link: entityLink.toLinkModel(),
      ViewName: typeof form._current.ReferenceView === 'undefined' ? '' : form._current.ReferenceView,
      ActionName: actionName,
      SerializedForm: serializedForm || {},
      CommandNumber: commandNumber || 0,
      CommandType: commandType || 0,
      CommandResult: commandResult || {},
    }).done((response) => {
      let responseAsObject = $.parseJSON(response);

      //скрываем сообщения о предыдущих ошибках, если были
      $.when(WA.FormControlsInit).then(() => {
        WA.CMP.NTF.InlineHint.hideAll();
      });

      // Применяем изменения к форме.
      let changes = responseAsObject.Changes;
      let changedMultiSelects = responseAsObject.ChangedMultiSelectRequisitesValues;
      if (form && form.isExist()) {
        form.applyServerSideChanges(changes, changedMultiSelects);
      }

      // Выполнение комманд.
      let cmds = responseAsObject.Commands;
      performCommands(cmds, entityLink, actionName, form);

      result.resolve();

    }).fail((errorMessage, response) => {
      // В ответе с ошибкой могут прийти изменения других реквизитов и их надо будет обработать.
      if (response) {
        if (response.Result) {
          let data = $.parseJSON(response.Result);
          // Применяем изменения к форме.
          let changes = data.Changes;
          let changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
          if (form && form.isExist()) {
            form.applyServerSideChanges(changes, changedMultiSelects);
          }
        }

        result.reject(response.Error);
      } else {
        result.reject();
      }
    });

    return result.promise();
  }

  /**
   * Выполняет список команд.
   * @since 5.0.0.1600
   * @private
   */
  function performCommands(cmds, entityLink, actionName, form) {
    let result = $.Deferred();
    if (cmds.length > 0) {
      // Результаты команд.
      let commandsResult = [];

      // Запускает последовательность команд.
      let allCommandsRunner = $.Deferred();

      // Последовательность всех команд.
      let allCommandsQueue;

      cmds.forEach((cmd, index) => {
        let cmdNumber = cmd.number;
        let cmdType = cmd.type;

        allCommandsQueue = allCommandsRunner.then(() => {
          // Отложенный запуск команды.
          switch (+cmdType) {
            case COMMAND_TYPE.SHOW_DIALOG:
              // Показать диалог.
              return performShowDialogCommand(cmd);
            case COMMAND_TYPE.END:
              // Завершающая команда.
              return performEndCommand();
            case COMMAND_TYPE.EXECUTE_SEARCH:
              // Выполнить поиск.
              return performExecuteSeachCommand(cmd);
            case COMMAND_TYPE.EXECUTE_JS_ACTION:
              // Выполнить js-функцию.
              return performExecuteJsActionCommand(cmd);
            case COMMAND_TYPE.SHOW_MESSAGE_BOX:
              // Показать модальное окно с кнопками.
              return performShowMessageBox(cmd);
            case COMMAND_TYPE.SHOW_NOTIFICATION:
              // Показать уведомление.
              return performShowNotification(cmd);
          }

        }).then((cmdResult) => {
          // Сохранить результат команды.
          commandsResult.push({
            number: cmdNumber,
            type: cmdType,
            result: cmdResult,
          });
        });
      });

      // Ожидание выполнения команд и отправка результата снова в действие.
      allCommandsQueue.done(() => {
        //TODO Шамов А.: Отправлять все результаты.
        setActionResultAndExecuteAgain(actionName, entityLink, form, {}, commandsResult[0].number, commandsResult[0].type, commandsResult[0].result).done(function () {
          result.resolve();
        });
      }).fail(() => {
        // Одна из команд прервала цепочку, остальные не выполняются и всё действие считаем незавершенным.
        result.reject();
      });

      // Запустить команды последовательно.
      allCommandsRunner.resolve();
    } else {
      result.resolve();
    }
    return result.promise();
  }

  /**
   * Выполняет команду "Показать диалог".
   * @since 5.0.0.1600
   * @private
   */
  function performShowDialogCommand(params) {
    let def = $.Deferred();

    window.WA.factories.dialogs.getObjectByInstanceID(params.InstanceID, MODEL.FULL).done((dialog) => {
      let showDialogParams = {
        freeAfterClosing: false,
      };
      dialog.show(showDialogParams);
      dialog.bind(WA.CMP.dialogs.FormDialog.EVENT.AFTER_ACTION, (actionName, result) => {

        let actionResult = {
          '__RESULT': result,
          '__RESULT_DIALOG': params.InstanceID,
        };

        def.resolve(actionResult);
      });
    }).fail(() => {
      def.reject();
    });

    return def.promise();
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Выполняет завершающую команду.
   * @since 5.0.0.1601
   * @private
   */
  function performEndCommand() {
    let def = $.Deferred();
    def.reject();
    return def.promise();
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Выполняет команду для показа результатов поиска.
   * @since 5.0.0.1601
   * @private
   */
  function performExecuteSeachCommand(params) {
    let def = $.Deferred();

    let form = new WA.CMP.forms.FormBuilder('SearchResultForm');
    // TODO Будет по ИД получать каждый из объектов. Надо оптимизировать!!!
    form.addObjectList('OBJECTS', params.SearchContentKind, params.SearchResult, true);

    let dialog = new WA.CMP.dialogs.BaseDialog('SearchResultDialog')
      .setTitle(L('SEARCH_RESULT_TITLE'))
      .setHtml(form.render())
      .setWidth(600)
      .show();

    //TODO Когда надо будет получения выбранных элементов, то resolve нужно вызывать после выбора.
    def.resolve();
    return def.promise();
  }

  /**
   * Выполняет указанную js-функцию.
   * @property {object} params - Параметры, с которыми вызывается команда
   * @property {string} params.jsActionName - Имя js-функции, которую должна запустить команда
   * @property {string} params.jsActionArgs - Аргументы js-функции в виде json-строки.
   * @property {object} params.isAsync - Признак асинхронности вызываемой js-функии.
   * @since 5.6.0.1000
   * @private
   */
  function performExecuteJsActionCommand(params) {
    let d = $.Deferred();
    let argsExpression;

    // Формируем выражение для аргументов функции
    if (params.jsActionArgs) {
      let parsedActionArgs = JSON.parse(params.jsActionArgs);
      if (Array.isArray(parsedActionArgs)) {
        // Функция с массивом параметров 
        const actionArgsArray = parsedActionArgs.map((item) => {
          return `${JSON.stringify(item)}`;
        });
        argsExpression = actionArgsArray.join(', ');
      } else {
        // Функция с единичным параметром
        argsExpression = params.jsActionArgs;
      }
    } else {
      // Функция без параметров
      argsExpression = '';
    }

    // Выполняем функцию
    const actionExpression = `return ${params.jsActionName}(${argsExpression});`;
    let result = Function(actionExpression).call();

    // Обрабатываем результат
    if (params.isAsync) {
      // Если функция асинхронная, то она нам вернула promise. Ждем, когда вернет отложенный результат
      result.done((asyncResult) => {
        d.resolve({
          '__RESULT': asyncResult,
        });
      }).fail(() => {
        d.reject();
      });
    } else {
      // Если функция синхронная, то она нам вернула результат
      d.resolve({
        '__RESULT': result,
      });
    }

    return d.promise();
  }

  /**
   * Показывает модальное окно с кнопками
   *
   * @function performShowMessageBox
   * @param {object} params - Параметры, с которыми вызывается команда
   * @property {string} params.message - Текст сообщения в модальном окне
   * @property {string} params.buttons - Кнопки, которые должны быть отображены в модальном окне
   * @property {string} params.title - Заголовок модального окна
   * @return {Deferred<Object>} Результат диалога.
   * @since 5.6.0.1000
   * @private
   */
  function performShowMessageBox(params) {
    let d = $.Deferred();
    let message = params.message;
    let buttons = params.buttons;
    let title = params.title;

    let dialog = new WA.CMP.dialogs.MessageBox();
    switch (buttons) {
      case 'OK':
        dialog.okButton(() => {
          d.resolve({__RESULT: 'OK'});
        });
        break;
      case 'YES_NO':
        dialog.yesNoButtons(() => {
          d.resolve({__RESULT: 'YES'});
        }, () => {
          d.resolve({__RESULT: 'NO'});
        });
        break;
      case 'OK_CANCEL':
        dialog.okCancelButtons(() => {
          d.resolve({__RESULT: 'OK'});
        }, () => {
          d.resolve({__RESULT: 'CANCEL'});
        });
        break;
    }
    dialog.setTitle(title);
    dialog.show(message);

    return d.promise();
  }

  /**
   * Показывает toast с уведомлением.
   *
   * @function performShowNotification
   * @param {object} params - Текст сообщения в модальном окне
   * @param {string} params.message - Имя js-функции, которую должна запустить команда
   * @return {Deferred<void>}
   * @since 5.6.0.1000
   * @private
   * @see https://api.jquery.com/category/deferred-object/
   */
  function performShowNotification(params) {
    let d = $.Deferred();
    let message = params.message;

    let toast = new WA.CMP.NTF.Toast();
    toast.showMessage(message);
    d.resolve();

    return d.promise();
  }


})(window.WebAccess.actions);